import { getFeatureSwitchValue } from '../utils/general';
export var FeatureSwitches = {
    /**
     * Purchase History Feature Switches:
     * - enableAndroidReceiptScanner - Enable Android Receipt Scanner
     * - OMS_VIEW_BIG_RECEIPT_SWITCH - enables the new OMS view big receipt
  
     * - allowViewSorisQrCode - allows the view of the SORIS QR code
     * - allowNativeAppInStoreReceiptPrint - allows native app in store receipt print
     */
    OMS_VIEW_BIG_RECEIPT_SWITCH: getFeatureSwitchValue('enableOMSViewBigReceipt'),
    allowNativeAppInStoreReceiptPrint: getFeatureSwitchValue('allowNativeAppInStoreReceiptPrint'),
    enableNewLoyaltySpendUI: getFeatureSwitchValue('enableNewLoyaltySpendUI', true),
    /**
     * Order Details Feature Switches:
     */
    remorseCancelPeriod: getFeatureSwitchValue('remorseCancelPeriod'),
    proSiteInstructionsMAEnabled: getFeatureSwitchValue('proSiteInstructionsMAEnabled'),
    /**
     * Start A Returns Feature Switches:
     * allowSTHUndeliveredReturns - allows STH undelivered returns
     */
    allowSTHUndeliveredReturns: getFeatureSwitchValue('allowSTHUndeliveredReturns', true),
    allowViewSorisQrCode: getFeatureSwitchValue('allowViewSorisQrCode', true),
    allowSORISCancel: getFeatureSwitchValue('allowSORISCancel', true),
    allowTrackingNumBasedShipments: getFeatureSwitchValue('allowTrackingNumBasedShipments', true),
    CXO_UPS_DEPLOYMENT_DATE: getFeatureSwitchValue('CXO_UPS_DEPLOYMENT_DATE', true),
    disableStartAReturn: getFeatureSwitchValue('disableStartAReturn', true),
    enableP0ReturnReceiptBarcode: getFeatureSwitchValue('enableP0ReturnReceiptBarcode', true),
    enableMACancelReasonCodes: getFeatureSwitchValue('enableMACancelReasonCodes'),
    ptcBectran: getFeatureSwitchValue('ptcBectran'),
    enableCPSSearch: getFeatureSwitchValue('enableCPSSearch', true),
    enableBopisOutOfStockRecoverability: getFeatureSwitchValue('enableBopisOutOfStockRecoverability'),
    enableProjectName: getFeatureSwitchValue('enableProjectName', true),
    enableEditDeliveryAddressAppify: getFeatureSwitchValue('enableEditDeliveryAddressAppify'),
    enableDeliveryTrackerReturnChanges: getFeatureSwitchValue('enableDeliveryTrackerReturnChanges', true),
    enableBopisOutOfStockSubstitution: getFeatureSwitchValue('enableBopisOutOfStockSubstitution'),
    enableCPSAnnouncementBanner: getFeatureSwitchValue('enableCPSAnnouncementBanner'),
    enableRefundBreakdown: getFeatureSwitchValue('enableRefundBreakdown'),
    enableNativeWallet: getFeatureSwitchValue('enableNativeWallet'),
    enableBopisOutOfStockFfaLiteCall: getFeatureSwitchValue('enableBopisOutOfStockFfaLiteCall'),
    isSFBLEnabled: getFeatureSwitchValue('isSFBLEnabled'),
    enableLSSCPS25MonthsDefault: getFeatureSwitchValue('enableLSSCPS25MonthsDefault', true),
};
